'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CardBody = require('./CardBody');

var _CardBody2 = _interopRequireDefault(_CardBody);

var _CardWrapper = require('./CardWrapper');

var _CardWrapper2 = _interopRequireDefault(_CardWrapper);

var _CardImage = require('./CardImage');

var _CardImage2 = _interopRequireDefault(_CardImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericCard = function GenericCard(_ref) {
  var border = _ref.border,
      bottomImage = _ref.bottomImage,
      cardHeadingTag = _ref.cardHeadingTag,
      creatorName = _ref.creatorName,
      creatorUrl = _ref.creatorUrl,
      description = _ref.description,
      exitUrl = _ref.exitUrl,
      imageAlt = _ref.imageAlt,
      imageSrc = _ref.imageSrc,
      presentational = _ref.presentational,
      rectangle = _ref.rectangle,
      square = _ref.square,
      tags = _ref.tags,
      title = _ref.title;

  var cardImageProps = {
    imageAlt: imageAlt,
    imageSrc: imageSrc,
    presentational: presentational,
    rectangle: rectangle,
    square: square,
    exitUrl: exitUrl
  };

  var cardBodyProps = {
    border: border,
    bottomImage: bottomImage,
    cardHeadingTag: cardHeadingTag,
    creatorName: creatorName,
    creatorUrl: creatorUrl,
    description: description,
    exitUrl: exitUrl,
    tags: tags,
    title: title
  };

  var cardImage = _react2.default.createElement(_CardImage2.default, _extends({}, cardImageProps, { imageAlt: title + ' by ' + creatorName }));

  return _react2.default.createElement(
    _CardWrapper2.default,
    null,
    _react2.default.createElement(_CardBody2.default, _extends({}, cardBodyProps, { cardImage: cardImage }))
  );
};

GenericCard.propTypes = {
  border: _react.PropTypes.bool,
  bottomImage: _react.PropTypes.bool,
  square: _react.PropTypes.bool,
  rectangle: _react.PropTypes.bool,
  exitUrl: _react.PropTypes.string,
  cardHeadingTag: _react.PropTypes.string,
  imageSrc: _react.PropTypes.string,
  imageAlt: _react.PropTypes.string,
  presentational: _react.PropTypes.bool,
  title: _react.PropTypes.string.isRequired,
  creatorName: _react.PropTypes.string,
  creatorUrl: _react.PropTypes.string,
  description: _react.PropTypes.string,
  tags: _react.PropTypes.arrayOf(_react.PropTypes.shape({ label: _react.PropTypes.string.isRequired, url: _react.PropTypes.string }).isRequired)
};

GenericCard.defaultProps = {
  border: true,
  bottomImage: false,
  square: false,
  rectangle: false
};

exports.default = GenericCard;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/base/lib/components/GenericCard.js
// module id = 656
// module chunks = 5 9